export default "__VITE_ASSET__NjIwjwOL__"